import React, { useContext, useEffect } from "react";
import TitleContext from "../context/TitleContext";
import CreateStaffForm from "../components/staff/CreateStaff";
const CreateStaffPage = () => {
  const { setTitle } = useContext(TitleContext);

  useEffect(() => {
    setTitle("Create Staff");
  }, [setTitle]);

  return (
    <>
      <CreateStaffForm />
    </>
  );
};
export default CreateStaffPage;
